import { type TypedDocumentNode, gql } from '@apollo/client';
import type { DiscoverInput } from '../hooks/types';

type GetDailyProgramsData = {
  discoverDaily: {
    programs: {
      leagueId?: string;
      gameId?: string;
      startDate: string;
    }[];
    count: number;
    endCursor: string;
  };
};

const GET_DAILY_PROGRAMS: TypedDocumentNode<GetDailyProgramsData, DiscoverInput> = gql`
  query discoverDaily($input: DiscoverInput!) {
    discoverDaily(input: $input) {
      programs {
        leagueId
        gameId
        startDate
      }
      count
      endCursor
    }
  }
`;

export default GET_DAILY_PROGRAMS;
